exports.onRouteUpdate = ({ location }) => {
  updateMenuSelection(location);
  initGTM();
}

const updateMenuSelection = (location) => {
  const path = location.pathname.replaceAll('/','')
  const node = document.getElementById(`menu-${path}`);
  if(!node) return;
  node.classList.add('selected');
}

const initGTM = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-0S445QJ1RW');
}